import type { DestinationEntry, GroupDestinations } from "./types";

const distinctLocators = (entries: DestinationEntry[]): boolean => {
  const seen = new Set<string>();
  for (const entry of entries) {
    const locator = entry.info.locator?.trim();
    if (!locator) return false;
    seen.add(locator);
  }
  return seen.size > 1;
};

/**
 * By name, in first-appearance order. A run of 62 smoke detectors is one thing
 * he is looking at, not sixty-two, and the card said it sixty-two times.
 *
 * Grouping is by name ALONE and never by adjacency: the run's order is not the
 * order he reads the plan in, so two blocks of the same detector separated by a
 * switch are still one product on this circuit.
 */
export const groupDestinations: GroupDestinations = ({ entries }) => {
  const byName = new Map<string, DestinationEntry[]>();
  entries.forEach((entry) => {
    const name = entry.info.name || "";
    const held = byName.get(name);
    if (held) {
      held.push(entry);
      return;
    }
    byName.set(name, [entry]);
  });

  return [...byName.entries()].map(([name, grouped]) => ({
    name,
    entries: grouped,
    hasDistinctLocators: distinctLocators(grouped),
  }));
};
